import Card from "components/card";
import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import Modal from "components/modal";
import Select from "components/select";
import Loader from "components/loader";
import { fetchScheduleShifts } from "services/schedule/kindergartenScheduleSlice";
import { fetchScheduleCourses } from "services/schedule/kindergartenScheduleSlice";
import Badge from "components/badge";
import { addSchedule } from "services/schedule/kindergartenScheduleSlice";
import Alert from "components/alert";
import { fetchSchedule } from "services/schedule/kindergartenScheduleSlice";
import { deleteSchedule } from "services/schedule/kindergartenScheduleSlice";
import { editSchedule } from "services/schedule/kindergartenScheduleSlice";

const KindergartenScheduleDetail = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", start: "", end: "" });
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [shift, setShift] = useState({});
  const [showModal, setShowModal] = useState(false);
  const kindergartenSchedule = useSelector((state) => {
    return state.kindergartenSchedule;
  });
  const inputs = [
    {
      id: "sch1",
      name: "name",
      type: "text",
      placeholder: "e.g. 2023 оны намарын хичээлийн хуваарь",
      errorMessage: "Хичээлийн хуваарь нэр 1-с дээш тэмдэгтээс бүрдэнэ!",
      label: "Хичээлийн хуваарь нэр",
      pattern: "^.+$",
      required: true,
    },
    {
      id: "sch2",
      name: "start",
      type: "date",
      placeholder: "Эхлэх огноо",
      errorMessage: "Эхлэх огноо оруулна уу",
      label: "Эхлэх огноо",
      required: true,
    },
    {
      id: "sch3",
      name: "end",
      type: "date",
      placeholder: "Дуусах огноо",
      errorMessage: "Дуусах огноо оруулна уу",
      label: "Дуусах огноо",
      required: true,
    },
  ];
  useEffect(() => {
    dispatch(fetchScheduleShifts());
    dispatch(fetchScheduleCourses());
    if (id) {
      dispatch(fetchSchedule(id)).then((response) => {
        if (response.payload.status) {
          const schedule = response.payload.result;
          values["name"] = schedule.name;
          values["start"] = schedule.start;
          values["end"] = schedule.end;
          setShift(schedule.shift.id);
          for (let course of schedule.courses) {
            selectedCourse.push(course);
          }
        }
      });
    }
    // eslint-disable-next-line
  }, [dispatch, id]);

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const removeCourse = (index) => {
    setSelectedCourse((selected) => {
      var sCourse = [...selected];
      sCourse.splice(index, 1);
      return sCourse;
    });
  };
  const addCourse = (e) => {
    e.preventDefault();
    setSelectedCourse((selected) => {
      var selectedCourseList = [...selected];
      var value = JSON.parse(e.target.value);
      const isAdded = selectedCourseList.findIndex(
        (item) => item.id.toString() === value.id.toString()
      );
      if (isAdded === -1) {
        selectedCourseList.push(value);
      }
      return selectedCourseList;
    });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      var selectedCourseList = [];
      for (let i = 0; i < selectedCourse.length; i++) {
        selectedCourseList.push(parseInt(selectedCourse[i].id));
      }
      const data = {
        name: values["name"],
        shift: shift,
        start: values["start"],
        end: values["end"],
        courses: selectedCourseList,
      };
      dispatch(id ? editSchedule({ id, data }) : addSchedule(data)).then(
        (response) => {
          if (response.payload !== undefined) {
            if (response.payload.status) {
              navigate("/admin/kindergarten_daily");
            }
          }
        }
      );
    }
  };

  const handleDelete = (e) => {
    dispatch(deleteSchedule(id)).then((response) => {
      if (response.payload.status) {
        navigate("/admin/kindergarten_daily");
      }
    });
  };

  return (
    <Card extra={"mt-4 w-full bg-white p-5"}>
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        <button
          className={`rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10  ${
            id ? "block" : "pt-30 hidden"
          }`}
          onClick={() => setShowModal(true)}
        >
          <MdDelete className="h-6 w-6 fill-red-600" />
        </button>
      </header>{" "}
      {kindergartenSchedule.loading && <Loader />}
      {!kindergartenSchedule.loading && kindergartenSchedule.error ? (
        <div className="lg:px-20">
          <Alert text={kindergartenSchedule.error} />
        </div>
      ) : null}
      {!kindergartenSchedule.loading &&
      kindergartenSchedule.shifts.length &&
      kindergartenSchedule.courses.length ? (
        <div className=" justify-start gap-5 lg:flex lg:px-20 lg:pb-20 ">
          <form onSubmit={handleSubmit}>
            {/* USER INPUTS  */}
            {inputs.map((input) => (
              <InputField
                key={"key" + input.id}
                id={input.id}
                className="lg:w-96"
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}

            <Select
              id="shift"
              value={shift}
              required={true}
              label="Ээлж"
              defaultText="Ээлж сонгоно уу."
              onChange={(selected) => {
                setShift(selected.target.value);
              }}
              children={kindergartenSchedule.shifts.map((row, index) => {
                return (
                  <option key={"shift" + index} value={row.id}>
                    {row.name}
                  </option>
                );
              })}
            />
            <label
              htmlFor={"angi_nemeh_label"}
              className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
            >
              Анги нэмэх
            </label>
            <br />
            {selectedCourse.map((row, index) => {
              return (
                <div>
                  <Badge
                    key={"course_badge" + index}
                    index={index}
                    text={row.number + row.group + " " + row.description}
                    remove={removeCourse}
                  />
                </div>
              );
            })}

            <Select
              id="course"
              required={false}
              value=""
              defaultText="Анги сонгоно уу."
              className="mt-2"
              onChange={addCourse}
              children={kindergartenSchedule.courses.map((row, index) => {
                return (
                  <option
                    key={"course_select" + index}
                    value={JSON.stringify(row)}
                  >
                    {row.number}
                    {row.group} {row.description}
                  </option>
                );
              })}
            />

            <CustomButton text="Хадгалах" type="submit" className="mr-3" />
            <CustomButton
              onClick={() => {
                navigate("/admin/kindergarten_daily");
              }}
              text="Буцах"
              isBack={true}
            />
          </form>
          {showModal ? (
            <Modal
              handleSubmit={handleDelete}
              setShowModal={setShowModal}
              child={
                <p className="text-xl text-navy-700 dark:text-white">
                  Та "{values["name"]}"-ыг устгахдаа итгэлтэй байна уу?
                  Дараахтай холбоотой бүх зүйл устаж болзошгүй
                </p>
              }
              title="Устгах"
            />
          ) : null}
        </div>
      ) : (
        <Alert text={kindergartenSchedule.error} />
      )}
    </Card>
  );
};

export default KindergartenScheduleDetail;
